import { HumanFemale } from "../assets/models/human-female";
import { HumanMale } from "../assets/models/human-male";

export enum GENDER {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export const GenderDictionary = {
  MALE: HumanMale,
  FEMALE: HumanFemale,
};
